import { useState, useEffect } from 'react'
import clsx from 'clsx'
import { Link, useNavigate,useSearchParams } from 'react-router-dom'
import moment from 'moment';
 
export function AppRedirect() {
  const [searchParams] = useSearchParams();
  const campaignId = searchParams.get('campaignId');
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!campaignId) {
      navigate('/app-redirect');
      return;
    }
    
    const userAgent = navigator.userAgent || navigator.vendor;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    
    let fallbackTimeout: ReturnType<typeof setTimeout>;
    let hasRedirected = false;
    
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // User opened app, cancel fallback
        clearTimeout(fallbackTimeout);
        hasRedirected = true;
      }
    };
    
    // Add listener before attempting deep link
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // Trigger the app deep link
    window.location.href = `elitelist://campaignDetails?campaignId=${campaignId}`;
    
    // Set fallback after 2.5s
    fallbackTimeout = setTimeout(() => {
      // Only redirect if the app hasn't been opened (page still visible)
      if (!document.hidden && !hasRedirected) {
        if (isIOS) {
          window.location.href = 'https://apps.apple.com/in/developer/elite-list/id1746565080';
        } else {
          navigate('/app-redirect');
        }
      }
    }, 2500);
    
    return () => {
      clearTimeout(fallbackTimeout);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [campaignId, navigate]);
  return (
    <section className="app-download py-5">
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-md-12 col-lg-12">
          <h2 className="display-6 fw-bold mb-4" style={{color:"#006CEA"}}>Available for</h2>
          <h3 className="display-5 fw-bolder mb-8">DOWNLOAD!</h3>
          
          <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
            <a href="https://apps.apple.com/in/developer/elite-list/id1746565080" className="download-badge position-relative transition">
              <img 
                src='https://www.kindpng.com/picc/m/56-562460_app-on-apple-store-hd-png-download.png' 
                alt="Download on App Store" 
                className="img-fluid" 
                style={{ maxWidth: "200px", height: "auto" }}
              />
              <div className="overlay position-absolute top-0 start-0 w-100 h-100 rounded-3"></div>
            </a>
            
            <a href="#" className="download-badge position-relative transition">
              <img 
                src='https://www.kindpng.com/picc/m/186-1863928_android-vector-android-available-on-app-store-hd.png' 
                alt="Get it on Google Play" 
                className="img-fluid" 
                style={{ maxWidth: "200px", height: "auto" }}
              />
              <div className="overlay position-absolute top-0 start-0 w-100 h-100 rounded-3"></div>
            </a>
          </div>
          
          <p className="text-muted fw-bold mt-8 text-sm" style={{fontSize:'14px;'}}>
            Download our app now and enjoy the full experience.
          </p>
        </div>
      </div>
    </div>
  </section>
  )
}
